// removed by extract-text-webpack-plugin
module.exports = {"MainPage":"_6Le2gQdMQudI7TA6cDvnK","lastSectionsWrapper":"Z3DJyswudBDwfICCKe7g2","descriptionBackground":"_7re_CVwbJJyaSSs2ZqX7B","contactBackground":"ZHoduIdYtc8laPVNmSgKP","widget":"_1u713gVlVX-WHlibIGLDqX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MainPage/MainPage.stylesheet.css
// module id = 232
// module chunks = 0